const inertia = 5;
let scrollY = 0;
let ticking = false;
let prevScrollY = 0;
const headerHeight = 100;
const removeScroll = 100;

function handleScrollUp() {
  prevScrollY = scrollY;
  scrollY = window.scrollY + inertia;

  if ( scrollY > headerHeight ) {
    document.body.classList.add( 'scrolled' );
    document.body.classList.remove( 'scrollUp' );
  }

  if ( scrollY > headerHeight ) {
    document.body.classList.toggle( 'scrollUp', scrollY < prevScrollY );
  }

  if ( scrollY < headerHeight ) {
    document.body.classList.remove( 'scrolled' );
  }

  if ( scrollY < removeScroll ) {
    document.body.classList.remove( 'scrollUp' );
  }

  ticking = false;
}

function requestTick() {
  if ( !ticking ) {
    window.requestAnimationFrame( handleScrollUp );
    ticking = true;
  }
}

function initEvents() {
  window.addEventListener( 'scroll', requestTick );
}

function init() {
  initEvents();
}

export default {
  init,
};
